<template>
	<div :class="_class" @click="$emit('click', $event)" @mousemove="$emit('mousemove', $event)" @mouseenter="$emit('mouseenter', $event)" @mouseleave="$emit('mouseleave', $event)">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'type-grid',
		props: {
			row: {
				type: [String, Number],
				default: 1,
				validator: value => Number(value) > 0
			},
			margin: {
				type: Boolean,
				default: false
			},
			padding: {
				type: Boolean,
				default: false
			},
			center: {
				type: Boolean,
				default: false
			},
			middle: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			_class() {
				let _class = 'type-grid';
				let row = this.row;
				if ([11, 12, 13, 14, 15, 16, 23, 34, 25, 35, 45, 56].indexOf(Number(row)) === -1) {
					row = '1' + ([1, 2, 3, 4, 5, 6].indexOf(Number(row)) > -1 ? row : 4);
				}
				if (this.center) {
					_class = 'type-grid-center';
				}
				if (this.middle) {
					_class = 'type-grid-middle';
				}
				if (this.margin) {
					return `${_class} grid-row${row}-margin`;
				}
				if (this.padding) {
					return `${_class} grid-row${row}-padding`;
				}
				return `${_class} grid-row${row}`;
			}
		}
	}
</script>

<style scoped lang="less">
	.type-grid{
		display: inline-block;
	}
	.type-grid-center{
		display: inline-flex;
		flex-wrap: wrap;
		justify-content: center;
	}
	.type-grid-middle{
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}
	.grid-row11{
		width: calc(100% / 1);
	}
	.grid-row11-margin{
		width: calc(100% / 1 - 30px);
	}
	.grid-row11-padding{
		width: calc(100% / 1 - 30px);
	}
	.grid-row11-margin, .grid-row12-margin, .grid-row13-margin, .grid-row14-margin, .grid-row15-margin, .grid-row16-margin, .grid-row23-margin, .grid-row34-margin, .grid-row25-margin, .grid-row35-margin, .grid-row45-margin, .grid-row56-margin{
		margin: 30px 15px;
	}
	.grid-row11-padding, .grid-row12-padding, .grid-row13-padding, .grid-row14-padding, .grid-row15-padding, .grid-row16-padding, .grid-row23-padding, .grid-row34-padding, .grid-row25-padding, .grid-row35-padding, .grid-row45-padding, .grid-row56-padding{
		padding: 30px 15px;
	}
	@media screen and (min-width: 1440px){
		.grid-row12{
			width: calc(100% / 2);
		}
		.grid-row13{
			width: calc(100% / 3);
		}
		.grid-row14{
			width: calc(100% / 4);
		}
		.grid-row15{
			width: calc(100% / 5);
		}
		.grid-row16{
			width: calc(100% / 6);
		}
		.grid-row23{
			width: calc(100% / 3 * 2);
		}
		.grid-row34{
			width: calc(100% / 4 * 3);
		}
		.grid-row25{
			width: calc(100% / 5 * 2);
		}
		.grid-row35{
			width: calc(100% / 5 * 3);
		}
		.grid-row45{
			width: calc(100% / 5 * 4);
		}
		.grid-row56{
			width: calc(100% / 6 * 5);
		}
		.grid-row12-margin, .grid-row12-padding{
			width: calc(100% / 2 - 30px);
		}
		.grid-row13-margin, .grid-row13-padding{
			width: calc(100% / 3 - 30px);
		}
		.grid-row14-margin, .grid-row14-padding{
			width: calc(100% / 4 - 30px);
		}
		.grid-row15-margin, .grid-row15-padding{
			width: calc(100% / 5 - 30px);
		}
		.grid-row16-margin, .grid-row16-padding{
			width: calc(100% / 6 - 30px);
		}
		.grid-row23-margin, .grid-row23-padding{
			width: calc(100% / 3 * 2 - 30px);
		}
		.grid-row34-margin, .grid-row34-padding{
			width: calc(100% / 4 * 3 - 30px);
		}
		.grid-row25-margin, .grid-row25-padding{
			width: calc(100% / 5 * 2 - 30px);
		}
		.grid-row35-margin, .grid-row35-padding{
			width: calc(100% / 5 * 3 - 30px);
		}
		.grid-row45-margin, .grid-row45-padding{
			width: calc(100% / 5 * 4 - 30px);
		}
		.grid-row56-margin, .grid-row56-padding{
			width: calc(100% / 6 * 5 - 30px);
		}
	}
	@media screen and (min-width: 1280px) and (max-width: 1439px){
		.grid-row12{
			width: calc(100% / 2);
		}
		.grid-row13{
			width: calc(100% / 3);
		}
		.grid-row14{
			width: calc(100% / 4);
		}
		.grid-row15, .grid-row16{
			width: calc(100% / 5);
		}
		.grid-row23{
			width: calc(100% / 3 * 2);
		}
		.grid-row34{
			width: calc(100% / 4 * 3);
		}
		.grid-row25{
			width: calc(100% / 5 * 2);
		}
		.grid-row35{
			width: calc(100% / 5 * 3);
		}
		.grid-row45, .grid-row56{
			width: calc(100% / 5 * 4);
		}
		.grid-row12-margin, .grid-row12-padding{
			width: calc(100% / 2 - 30px);
		}
		.grid-row13-margin, .grid-row13-padding{
			width: calc(100% / 3 - 30px);
		}
		.grid-row14-margin, .grid-row14-padding{
			width: calc(100% / 4 - 30px);
		}
		.grid-row15-margin, .grid-row15-padding, .grid-row16-margin, .grid-row16-padding{
			width: calc(100% / 5 - 30px);
		}
		.grid-row23-margin, .grid-row23-padding{
			width: calc(100% / 3 * 2 - 30px);
		}
		.grid-row34-margin, .grid-row34-padding{
			width: calc(100% / 4 * 3 - 30px);
		}
		.grid-row25-margin, .grid-row25-padding{
			width: calc(100% / 5 * 2 - 30px);
		}
		.grid-row35-margin, .grid-row35-padding{
			width: calc(100% / 5 * 3 - 30px);
		}
		.grid-row45-margin, .grid-row45-padding, .grid-row56-margin, .grid-row56-padding{
			width: calc(100% / 5 * 4 - 30px);
		}
	}
	@media screen and (min-width: 1080px) and (max-width: 1279px){
		.grid-row12{
			width: calc(100% / 2);
		}
		.grid-row13, .grid-row25{
			width: calc(100% / 3);
		}
		.grid-row14, .grid-row15, .grid-row16{
			width: calc(100% / 4);
		}
		.grid-row23, .grid-row35{
			width: calc(100% / 3 * 2);
		}
		.grid-row34, .grid-row45, .grid-row56{
			width: calc(100% / 4 * 3);
		}
		.grid-row12-margin, .grid-row12-padding{
			width: calc(100% / 2 - 30px);
		}
		.grid-row13-margin, .grid-row13-padding, .grid-row25-margin, .grid-row25-padding{
			width: calc(100% / 3 - 30px);
		}
		.grid-row14-margin, .grid-row14-padding, .grid-row15-margin, .grid-row15-padding, .grid-row16-margin, .grid-row16-padding{
			width: calc(100% / 4 - 30px);
		}
		.grid-row23-margin, .grid-row23-padding, .grid-row35-margin, .grid-row35-padding{
			width: calc(100% / 3 * 2 - 30px);
		}
		.grid-row34-margin, .grid-row34-padding, .grid-row45-margin, .grid-row45-padding, .grid-row56-margin, .grid-row56-padding{
			width: calc(100% / 4 * 3 - 30px);
		}
	}
	@media screen and (min-width: 720px) and (max-width: 1079px){
		.grid-row12{
			width: calc(100% / 2);
		}
		.grid-row13, .grid-row14, .grid-row15, .grid-row16, .grid-row25{
			width: calc(100% / 3);
		}
		.grid-row23, .grid-row34, .grid-row35, .grid-row45, .grid-row56{
			width: calc(100% / 3 * 2);
		}
		.grid-row12-margin, .grid-row12-padding{
			width: calc(100% / 2 - 30px);
		}
		.grid-row13-margin, .grid-row13-padding, .grid-row14-margin, .grid-row14-padding, .grid-row15-margin, .grid-row15-padding, .grid-row16-margin, .grid-row16-padding, .grid-row25-margin, .grid-row25-padding{
			width: calc(100% / 3 - 30px);
		}
		.grid-row23-margin, .grid-row23-padding, .grid-row34-margin, .grid-row34-padding, .grid-row35-margin, .grid-row35-padding, .grid-row45-margin, .grid-row45-padding, .grid-row56-margin, .grid-row56-padding{
			width: calc(100% / 3 * 2 - 30px);
		}
	}
	@media screen and (min-width: 560px) and (max-width: 719px){
		.grid-row12, .grid-row13, .grid-row14, .grid-row15, .grid-row16, .grid-row23, .grid-row34, .grid-row25, .grid-row35, .grid-row45, .grid-row56{
			width: calc(100% / 2);
		}
		.grid-row12-margin, .grid-row12-padding, .grid-row13-margin, .grid-row13-padding, .grid-row14-margin, .grid-row14-padding, .grid-row15-margin, .grid-row15-padding, .grid-row16-margin, .grid-row16-padding, .grid-row23-margin, .grid-row23-padding, .grid-row34-margin, .grid-row34-padding, .grid-row25-margin, .grid-row25-padding, .grid-row35-margin, .grid-row35-padding, .grid-row45-margin, .grid-row45-padding, .grid-row56-margin, .grid-row56-padding{
			width: calc(100% / 2 - 30px);
		}
	}
	@media screen and (max-width: 559px){
		.grid-row12, .grid-row13, .grid-row14, .grid-row15, .grid-row16, .grid-row23, .grid-row34, .grid-row25, .grid-row35, .grid-row45, .grid-row56{
			width: calc(100% / 1);
		}
		.grid-row12-margin, .grid-row12-padding, .grid-row13-margin, .grid-row13-padding, .grid-row14-margin, .grid-row14-padding, .grid-row15-margin, .grid-row15-padding, .grid-row16-margin, .grid-row16-padding, .grid-row23-margin, .grid-row23-padding, .grid-row34-margin, .grid-row34-padding, .grid-row25-margin, .grid-row25-padding, .grid-row35-margin, .grid-row35-padding, .grid-row45-margin, .grid-row45-padding, .grid-row56-margin, .grid-row56-padding{
			width: calc(100% / 1 - 30px);
		}
	}
</style>
